import { useQuery } from '@tanstack/react-query'
import { topFeaturesKeys } from '@!/Api/queryKeys'
import { getTopFeaturesApi } from '@!/Api/features'
import { useAtom } from 'jotai'
import { safeSearchAtom } from '@!/atoms/safeSearchAtom'
import { useState, useEffect } from 'react'

const MAX_PAGES = 4

export const useTopFeatures = (genreName = null) => {
  const [safeSearch] = useAtom(safeSearchAtom)
  const [features, setFeatures] = useState([])
  const [page, setPage] = useState(1)

  const { data: featuresData } = useQuery({
    queryKey: topFeaturesKeys.filtered(safeSearch, genreName, page),
    queryFn: async () => {
      return await getTopFeaturesApi(safeSearch, genreName, page)
    },
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  })

  // 特集データを5件ずつ取得する(最大20件まで)
  useEffect(() => {
    if (featuresData && featuresData.features && featuresData.features.length > 0) {
      setFeatures((prev) => [...prev, ...featuresData.features])
      if (featuresData.next_page && page < MAX_PAGES) {
        setPage(featuresData.next_page)
      }
    }
  }, [featuresData, page])

  return features
}
